export default {
  text: 'black',
  primary: '#b62127',
  secondary: 'black',
  background: 'white',
  backgroundSecondary: '#ddd1bf',
  light: '#fdfdfd',
  dark: '#202020',
};
